(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupsViewModel', UserGroupsViewModelFactory);

  /** @ngInject */
  function UserGroupsViewModelFactory(userGroupActions, gridUtils, dialogsService, $translate, UserGroupItemViewModel) {
    function UserGroupsViewModel() {
      this.currentPage = 1;
      this.orderBy = 'name';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_USER_GROUP_ERROR')

      init.call(this);
    }

    UserGroupsViewModel.prototype.destroy = function () {
      this.data.forEach(function (groupItemViewModel) {
        groupItemViewModel.destroy();
      });
    };

    UserGroupsViewModel.prototype.deleteSelectedGroup = function () {
      var that = this;
      dialogsService.showConfirmDialog('CONFIRM_DELETE_USER_GROUP', 'CONFIRM_DELETE_USER_GROUP_TEXT', 'DELETE')
        .then(function () {
          userGroupActions.deleteUserGroup(that.selected[0].id).then(function () {
            refresh.call(that);
          }, function () {
            that.hasErrorMessage = true;
          });
        });
    };

    return UserGroupsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.pagerLabel = gridSettings.translations;

      refresh.call(this);
    }

    function refresh() {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;
      this.emptyList = false;
      this.hasErrorMessage = false;
      userGroupActions.getUserGroups().then(function (groupsJson) {
        if (groupsJson && groupsJson.length > 0) {
          that.count = groupsJson.length;
          groupsJson.forEach(function (groupJson) {
            this.push(new UserGroupItemViewModel(groupJson));
          }, that.data);
        }else{
          that.emptyList = true;
        }
      });
    }
  }
})();
